import { createAsyncThunk } from "@reduxjs/toolkit";
import { getHeaders, 
  getCommonLabels,
  addCommonLabels as postCommonLabels,
  updateCommonLabels as putCommonLabels,
  deleteCommonLabels as removeCommonLabels,
  activateDeactivateCommonLabels as activateCommonLabels
} from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";
import { t } from "i18next";


// Fetch Table Column Names
export const fetchDifficultyLevelTableColumnNames = createAsyncThunk("difficultyLevel/fetchTableColumnNames", async (difficultyLevel, thunkAPI) => {
    try {
      const response = await getHeaders(difficultyLevel); 
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Fetch All Difficulty Level
export const fetchAllDifficultyLevel = createAsyncThunk("difficultyLevel/fetchAll", async (difficultyLevel, thunkAPI) => {
    try {
      const response = await getCommonLabels(difficultyLevel); 
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Add Difficulty Level
export const createDifficultyLevel = createAsyncThunk("difficultyLevel/add", async (difficultyLevel, thunkAPI) => {  
    try {
        const response = await postCommonLabels(difficultyLevel);
        toast.success(t(response.message));
        return response;
    } catch (error) {
        toast.error(error.message);
        return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Update Difficulty Level
export const updateDifficultyLevel = createAsyncThunk("difficultyLevel/update", async (difficultyLevel, thunkAPI) => {
    try {
        const response = await putCommonLabels(difficultyLevel);
        toast.success(t(response.message));
        return response.data;
    } catch (error) {
        toast.error(error.message);
        return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Delete Difficulty Level
export const deleteDifficultyLevel = createAsyncThunk("difficultyLevel/delete", async (difficultyLevel, thunkAPI) => {
    try {
        const response = await removeCommonLabels(difficultyLevel);
        toast.success(t(response.message));
        return response.data;
    } catch (error) {
        toast.error(error.message)
        return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Activate Deactivate Difficulty Level
export const activateDeactivateDifficultyLevel = createAsyncThunk("difficultyLevel/activateDeactivate", async (difficultyLevel, thunkAPI) => {
  try {
    const response = await activateCommonLabels(difficultyLevel);
    toast.success(t(response.message));
    return response.data;
  } catch (error) {
    toast.error(error.message)
    return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
  }
});